// removed by extract-text-webpack-plugin
module.exports = {"inputGroup":"_10Rk3Vv_yK70g9KPvRW8dZ","label":"_1xNqQ7IamQlOTYu-rhybj9"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-gui/src/modules/01-molecules/form-elements/input-field.scss
// module id = 81
// module chunks = 0